import gluedin from "gluedin-shorts-js";
import { useEffect, useState } from "react";

const feedModule = new gluedin.GluedInFeedModule();

export default function useLikedVideo(videoId: string, enabled = true) {
  const [isVideoLiked, setIsVideoLiked] = useState(false);
  const [isLoading, setIsLoading] = useState(enabled);
  const userData = localStorage.getItem("userData");
  useEffect(() => {
    if (!enabled) {
      setIsLoading(false);
      return;
    }
    if (!userData || !videoId) {
      setIsLoading(false);
      return;
    }
    const fetchLikedVideo = async () => {
      setIsLoading(true);
      try {
        const {
          status,
          data: { result: likedVideoId },
        } = await feedModule.Like([videoId]);
        if (status === 200 || status === 201) {
          if (likedVideoId.length) {
            setIsVideoLiked(true);
          } else {
            setIsVideoLiked(false);
          }
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error(error);
      }
    };
    fetchLikedVideo();
  }, [enabled, userData, videoId]);

  return {
    isLoading,
    isVideoLiked,
    setIsVideoLiked,
  };
}
